export default "__VITE_ASSET__Ddy0_Gp$__"